import { specialties } from "./data";
import { Reveal } from "./Reveal";

export function SpecialtiesSection() {
  return (
    <section className="section specialties-section" id="specialties">
      <div className="container">
        <Reveal>
          <div className="section-label"><span className="chapter-no">04</span>Areas of expertise</div>
          <div className="section-head"><h2>Specialist care for every urological concern.</h2><p>Advanced, minimally invasive treatments with a patient-centred approach. Tap any area for a clear patient guide.</p></div>
        </Reveal>
        <div className="specialty-grid">
          {specialties.map(([icon, title, text, slug], index) => (
            <Reveal key={title} delay={(index % 4) * 0.07}>
              <a className="specialty-card" href={`/conditions/${slug}/`} data-testid={`specialty-card-${index}`}>
                <span className="specialty-icon">{icon}</span>
                <span className="card-index">{String(index + 1).padStart(2, "0")}</span>
                <h3>{title}</h3>
                <p>{text}</p>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
